import { environment } from "environments/environment"

export const processingFeeDetails: any = {
    fee: environment.PROCESSING_FEE
}